/* eslint-disable react-hooks/exhaustive-deps */
import Listado from 'components/public/Listado/Listado';
import Spinner from 'components/public/Spinner/Spinner';
import NoResponse from 'pages/auxiliares/NoResponse';
import NotAllowed from 'pages/auxiliares/NotAllowed';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { titulosListadoUsuario } from 'utils/constants';
import { UsuarioBase } from 'utils/models/types';
import { fetchUsuarioId } from 'utils/redux/features/usuarioIdSlice';
import { fetchUsuarios } from 'utils/redux/features/usuariosSlice';
import { AppDispatch, RootState } from 'utils/redux/store/store';

const Usuarios = () => {
  const navigate = useNavigate();
  const { usuarios, loadingUsuarios, errorUsuarios } = useSelector((state: RootState) => state.usuarios);
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchUsuarios());
  }, [dispatch]);

  const onAgregar = () => {
    navigate(`/admin/alta-usuario`);
  };

  const onEditar = (id: number) => {
    dispatch(fetchUsuarioId(Number(id)));
    navigate(`/admin/usuarios/${id}`);
  };

  const onEliminar = (id: number) => {
    navigate(`/admin/usuarios/baja/${id}`);
  };

  const usuariosListado: UsuarioBase[] = usuarios.map((u: UsuarioBase) => {
    return {
      Id: u.Id,
      Activo: u.Activo ? 'Sí' : 'No',
      Confirmado: u.Confirmado ? 'Sí' : 'No',
      Nombre: `${u.Nombre} ${u.Apellido}`,
      Email: u.Email,
      Password: u.Password,
      Rol: u.Rol,
      FechaNac: u.FechaNac || 'No ingresada',
      DescuentoAsignado:
        typeof u.DescuentoAsignado === 'number' && u.DescuentoAsignado > 0 ? `${u.DescuentoAsignado}%` : '-',
      Telefono: u.Telefono || '-',
      EsElenco: u.EsElenco ? 'Sí' : 'No',
      EsAlumno: u.EsAlumno ? 'Sí' : 'No',
      TipoSocio: u.TipoSocio !== 'Nada' ? u.TipoSocio : '-',
      DetallePath: `/admin/usuarios/${u.Id}`,
    };
  });

  const error401 = errorUsuarios?.includes('permisos');

  return loadingUsuarios ? (
    <Spinner />
  ) : errorUsuarios ? (
    error401 ? (
      <NotAllowed />
    ) : (
      <NoResponse />
    )
  ) : (
    <Listado
      lista={usuariosListado}
      headCells={titulosListadoUsuario}
      titulo="Gestionar usuarios"
      onAgregar={onAgregar}
      onEditar={onEditar}
      onEliminar={onEliminar}
      loading={loadingUsuarios}
    />
  );
};

export default Usuarios;
